var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageSize main"},[_c('div',{staticClass:"analysisReportPage",staticStyle:{"position":"absolute","right":"60px","bottom":"60px","font-size":"20px","color":"#000"}},[_vm._v(" 2 of "+_vm._s(_vm.pageAllNum)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }